export default {
  Home: 'Hogar',
  Work: 'Trabajar',
  Other: 'Otro',
  Shipping: 'Transporte',
  'Home Address': 'Direccion de Casa',
  'Marketing Address': 'Dirección de Comercialización',
  'Service Address': 'Dirección de Servicio',
  'Shipping Address': 'Dirección de Envío',
  'Work Address': 'Dirección de Trabajo'
};
